import { render, staticRenderFns } from "./AddGrant.vue?vue&type=template&id=d9d9f720&scoped=true"
import script from "./AddGrant.vue?vue&type=script&lang=js"
export * from "./AddGrant.vue?vue&type=script&lang=js"
import style0 from "./AddGrant.vue?vue&type=style&index=0&id=d9d9f720&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d9f720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9d9f720')) {
      api.createRecord('d9d9f720', component.options)
    } else {
      api.reload('d9d9f720', component.options)
    }
    module.hot.accept("./AddGrant.vue?vue&type=template&id=d9d9f720&scoped=true", function () {
      api.rerender('d9d9f720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/AddGrant.vue"
export default component.exports